module.exports = __webpack_public_path__ + "img/智慧水利.f1344873.png";